import { render, staticRenderFns } from "./chat-search.vue?vue&type=template&id=773dd013&scoped=true"
import script from "./chat-search.vue?vue&type=script&lang=js"
export * from "./chat-search.vue?vue&type=script&lang=js"
import style0 from "./chat-search.vue?vue&type=style&index=0&id=773dd013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773dd013",
  null
  
)

export default component.exports